import React from "react";
import { AlertCircle, CheckCircle } from "lucide-react";
import { CUSTOMER_SUCCESS_EMAIL } from "config/constant";

interface PermissionAlertsProps {
  permissions: any;
  canCreateProject: boolean;
  mode: "project" | "version";
}

export const PermissionAlerts: React.FC<PermissionAlertsProps> = ({
  permissions,
  canCreateProject,
  mode,
}) => {
  return (
    <>
      {/* Trial Badge */}
      {permissions.hasActiveTrial &&
        permissions.trialDaysRemaining > 0 &&
        !permissions.isOneTimePurchase && (
          <div className="mb-6 p-4 bg-success/10 border border-success/20 rounded-lg">
            <div className="flex items-center gap-2 text-success">
              <CheckCircle className="w-4 h-4" />
              <span className="text-sm font-medium">Free Trial Active</span>
              <span className="text-xs bg-success/20 px-2 py-1 rounded-full">
                {permissions.trialDaysRemaining} days left
              </span>
            </div>
            <p className="text-xs text-success/80 mt-1">
              You're currently using your free trial. You have full access to all features for{" "}
              {permissions.trialDaysRemaining} more days.
            </p>
          </div>
        )}

      {/* Permission Warning */}
      {!canCreateProject && mode === "project" && (
        <div className="mb-6 p-4 bg-warning/10 border border-warning/20 rounded-lg">
          <div className="flex items-center gap-2 text-warning">
            <AlertCircle className="w-4 h-4" />
            <span className="text-sm font-medium">Limited Access</span>
          </div>
          <p className="text-xs text-warning/80 mt-1">
            {permissions.isDeactivated
              ? `Your account has been deactivated. Please contact ${CUSTOMER_SUCCESS_EMAIL}.`
              : permissions.isOneTimePurchase
                ? "You don't have available licenses or trials. Please purchase additional licenses to create new projects."
                : permissions.isSubscriptionExpired
                  ? "Your subscription has expired. Please renew to create new projects."
                  : "You have reached your project quota. Please upgrade your plan to create more projects."}
          </p>
          <p className="text-xs text-warning/60 mt-2">
            You can still fill out the form, but project creation may be restricted.
          </p>
        </div>
      )}
    </>
  );
};
